import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import currentWidgetDetails from "utilities/platform/widget-details";














export default class AhAuthcodeCommonsUtility {
    constructor(options) {
        this.$ = options.$;
        this._ = options._;
        this.cawCommons = options.cawCommons;
        this.cawEventsMaster = options.cawEventsMaster;
        this.constructorParams = options.constructorParams;
        this.parentModule = options.context;
        this.spartaUILayersUtility = options.spartaUILayersUtility;
        this.spartaMessageUtil = options.spartaMessageUtil;
        this.spartaValidationFramework = options.spartaValidationFramework;
        this.jsEncrypt = options.jsEncrypt;
        this.Handlebars = options.hb;
        this.parentModule.clientParams = this.constructorParams.clientParams;
        this.parentModule.i18n = this.constructorParams.i18n;

        window.jQuery = this.$;



        for (let prop in this) {
            if (this[prop] === undefined) {
                throw `AhAuthcodeCommonsUtility failed to initialize. '${prop}' is not defined.`;
            } else {

            }
        }


        let basePath = this.cawCommons.getBasePath(this.parentModule.spaParams);
        if (this._.get(this, "parentModule.clientParams.useRelativePath") === true) {
            this.parentModule["apiEndPoints"] =
                this.constructorParams.apiEndPoints;
        } else {
            this.parentModule["apiEndPoints"] = this.cawCommons.getEndPoints(this.constructorParams.apiEndPoints, basePath);
        }

        if (document.location.href.indexOf("mock=true") !== -1) {
            this.parentModule.queryParams = new URLSearchParams(window.location.search);
        }
    }

    defineVars() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const showHeaderWithCardDetails = false;
        otacModule.templates = {};


        otacModule.$moduleContext = $(otacModule.view.settings.target);
        otacModule.modalWindowClass = `${otacModule.$moduleContext.attr("class").split(" ")[0]}-modalwindow`;
        otacModule.otpRadioName = "contact";
        otacModule.cardsRadioName = "cardsSelect";
        otacModule.textVoiceRadio = "textVoiceRadio";

        otacModule.modalContentWrapperID = "ah-widget-modal-wrapper";


        otacModule.otpWidgetSectionID = "#ah-otp-widget";
        const WIDGET_TYPE = { MODAL: "modal", PAGE: "page", UCI: "uci" };
        otacModule.WIDGET_TYPE = WIDGET_TYPE;

        otacModule.LINK = {
            SEND_OTP_CODE: `#send-otp-code`,
            CANCEL_REQUEST_OTP: `#cancel-request-otp`,
            CANCEL_ENTRY_OTP: `#cancel-entry-otp`,
            ALREADY_HAVE_AUTH: `#already-have-auth`,
            VALIDATE_OTP_CODE: `#validate-otp-code`,
            TW_VALIDATE_OTP_CODE: `#submit-otp-code`,
            ALREADY_HAVE_AUTH_CLASS: "link-have-auth",
            SHOW_EMAIL_CONTACTS: `#show-email-contacts`,
            TROUBLE_WITH_EMAIL: `#trouble-with-email`,
        };


        otacModule.INPUT = {
            INITIAL: {
                OTP_CODE: '#otp-code',
                CVV: '#creditc-sec',
                DEBIT_PIN: '#debitc-pin',
                EXPIRY_DATE: '#creditc-exp'
            },
            ACTUAL: {
                OTP_CODE: '#otp-code',
                CVV: '#creditc-sec',
                DEBIT_PIN: '#debitc-pin',
                EXPIRY_DATE: '#creditc-exp'
            }
        };

        otacModule.PASSWORDINPUTS = [otacModule.INPUT.INITIAL.CVV, otacModule.INPUT.INITIAL.DEBIT_PIN]










        otacModule.SECTIONS = {};
        otacModule.SECTIONS.HEAD = {
            OTP: otacModule.otpWidgetSectionID,
            MODAL_CONTENT: `#${otacModule.modalContentWrapperID}`
        };

        otacModule.SECTIONS.OTP = {
            REQUEST_OTP: "#requestAuthStep",
            ENTER_OTP: "#enterAuthStep",
            UCI_REQUEST_OTP: "#uciRequestAuthStep",
            CONFIRM_BEFORE_CLOSE: "#confirmBeforeCloseStep"
        };

        otacModule._data = {};
        otacModule._data.OTP = {
            selectedContact: "",
            selectedContactType: ""
        };

        otacModule.EVENTS = {
            OTP_INITIATE: "AH_UNIVERSAL_OTP_INITIATE",
            OTP_FINALIZE: "AH_UNIVERSAL_OTP_FINALIZE",
            OTP_NOT_REQUIRED: "AH_UNIVERSAL_OTP_NOT_REQUIRED",
            OTP_VALIDATE_CODE_SUCCESS: "AH_UNIVERSAL_OTP_VALIDATE_CODE_SUCCESS",
            OTP_VALIDATE_CODE_SUCCESS_RESPONSE: "AH_UNIVERSAL_OTP_VALIDATE_CODE_SUCCESS_RESPONSE",
            OTP_VALIDATE_CODE_FAILURE: "AH_UNIVERSAL_OTP_VALIDATE_CODE_FAILURE",

            OTP_REQUEST_CANCEL: "AH_UNIVERSAL_OTP_REQUEST_CANCEL",
            OTP_ENTRY_CANCEL: "AH_UNIVERSAL_OTP_ENTRY_CANCEL",
            OTP_REQUEST_CONFIRM_CANCEL: "AH_UNIVERSAL_OTP_REQUEST_CONFIRM_CANCEL",
            OTP_ENTRY_CONFIRM_CANCEL: "AH_UNIVERSAL_OTP_ENTRY_CONFIRM_CANCEL",
            OTP_INITIATE_FAIL: "AH_OTP_INITIATE_FAIL",
            OTP_FATAL_ERROR: "AH_UNIVERSAL_OTP_FATAL_ERROR",
            OTP_SEND_CODE: "AH_UNIVERSAL_OTP_SEND_CODE",
            OTP_SEND_CODE_SUCCESS: "AH_UNIVERSAL_OTP_SEND_CODE_SUCCESS",
            OTP_SEND_CODE_FAILURE: "AH_UNIVERSAL_OTP_SEND_CODE_FAILURE",
            OTP_VALIDATE_CODE: "AH_UNIVERSAL_OTP_VALIDATE_CODE",
            OTP_HAVE_AUTH_SUCCESS: "AH_UNIVERSAL_OTP_HAVE_AUTH_SUCCESS",
            OTP_HAVE_AUTH_FAILURE: "AH_UNIVERSAL_OTP_HAVE_AUTH_FAILURE",
            AUTH_INITIATE_STEPUP_FAIL: "AH_UNIVERSAL_AUTH_INITIATE_STEPUP_FAIL",
            AUTH_INITIATE_STEPUP_COMPLETE: "AH_UNIVERSAL_AUTH_INITIATE_STEPUP_COMPLETE",
            AUTH_INITIATE_STEPUP_SUCCESS: "AH_UNIVERSAL_AUTH_INITIATE_STEPUP_SUCCESS",
            OTP_FALLBACK_CQ: "AH_UNIVERSAL_OTP_FALLBACK_CQ",
        };


        otacModule.recentActiveStep = "";


        self.getContext().removeAttr('data-options');
        self._fixInputsForMultiOtac();

        otacModule.CACHED = {};
        otacModule.CACHED._WidgetContainerRoot = otacModule.$moduleContext.find("#ah-authcode-container");
        otacModule.CACHED._OtpWidgetInitialDom = otacModule.CACHED._WidgetContainerRoot.find("> .ah-otp-widget").clone();

        otacModule.consentOnScreenErrorCodes = ["E0017", "INVALID_AUTH_CODE", "INVALID_AUTHCODE_OR_CARD", "INVALID_AUTHCODE_OR_DEBIT_CARD",
            "INVALID_AUTHCODE_OR_CREDIT_CARD", "E0039", "E0040"
        ];

        otacModule.PAGE_WITH_SPA_EVENT = "CRDREISSUE";
        otacModule.STEPS_TO_SKIP = [];
        otacModule.STEPS = {
            STEP_INITIATE_STEPUP: "INITIATE_STEPUP",
            STEP_SHOW_CONTACTS: "SHOW_CONTACTS",
            STEP_SHOW_VALIDATE_CODE: "SHOW_VALIDATE_CODE",
        };
        return self;
    }

    begin() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;


        if (self._isPage() && otacModule.clientParams["auto-initialize"] === true) {
            self.publishEvent(self.EVENTS.OTP_INITIATE);
        }

        return self;
    }

    compileAllTemplates() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;

        let allTemplates = otacModule.$moduleContext.find('template[type="text/x-handlebars-template"]');

        allTemplates.each(function() {
            otacModule.templates[$(this).attr("template-name")] = self.Handlebars.compile(
                $(this)
                    .html()
                    .replace(/\[\[/g, "{{")
                    .replace(/\[\[\[/g, "{{{")
                    .replace(/\]\]/g, "}}")
                    .replace(/\]\]\]/g, "}}}")
            );
        });

        return self;
    }

    subscribeEvents() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        self.subscribeEvent(otacModule.EVENTS.OTP_INITIATE, e => {
            if (_.get(e, "data.source") === "WIDGET") {
                otacModule.moduleSource = "secure-authcode-widget"; 

                otacModule.clientParams.pageID = _.get(e, "data.pageID");
                const $jContext = self.getContext();
                if (_.get(e, "data.showcancel") === true) {
                    $jContext.find(".btn-cancel").remove();
                }








                if (_.get(e, "data.widgetType") === "UCI") {
                    otacModule.clientParams["widget-type"] = otacModule.WIDGET_TYPE.UCI;
                    $jContext.find("#ah-otp-widget").removeClass("hide");
                } else if (_.get(e, "data.widgetType") === "PAGE") {
                    otacModule.clientParams["widget-type"] = otacModule.WIDGET_TYPE.PAGE;
                    $jContext.find("#ah-otp-widget").removeClass("hide");
                } else {
                    otacModule.clientParams["widget-type"] = otacModule.WIDGET_TYPE.MODAL;
                }

            }

            self
                .getContext()
                .find("#ah-authcode-container")
                .removeClass("hidden");
            if (self._isStandAlone()) {
                self
                    .getContext()
                    .find(otacModule.SECTIONS.HEAD.OTP)
                    .addClass("skin-standalone");
            }
            otacModule.clientParams.forcedOtp = false;

            if (e && e.data && e.data.forcedOtp) {
                otacModule.clientParams.forcedOtp = e.data.forcedOtp;
            }

            if (_.get(e, "data.passThroughPayload")) {
                otacModule.clientParams.passThroughPayload = _.get(e, "data.passThroughPayload");
            }

            if (e && _.get(e, "data.restrictTypeList") && _.get(e, "data.restrictTypeList").length > 0) {
                if(_.get(e, "data.restrictTypeList").includes("MTG")) {
                    otacModule.clientParams.restrictMTG = true;
                }
            }







            otacModule.STEPS_TO_SKIP = [];
            if ( _.get(e, "data.firstStep") === 'SHOW_CONTACTS'){
                otacModule.STEPS_TO_SKIP.push(otacModule.STEPS.STEP_INITIATE_STEPUP);
                otacModule.clientParams["helper-data"] = _.get(e, "data.helper-data");
            } else if ( _.get(e, "data.firstStep") === 'SHOW_ENTER_AUTHCODE'){
                otacModule.STEPS_TO_SKIP.push(otacModule.STEPS.STEP_INITIATE_STEPUP);
                otacModule.clientParams["helper-data"] = _.get(e, "data.helper-data");


                let selectedContactValue = otacModule.clientParams["helper-data"].stepUpSecuredContactPoints[0].maskedContactPoint.value;
                let selectedContactEncrypted = otacModule.clientParams["helper-data"].stepUpSecuredContactPoints[0].encryptedContactPoint.value;
                let deliveryMethod = otacModule.clientParams["helper-data"].stepUpSecuredContactPoints[0].deliveryMethod;

                otacModule.clientParams["helper-data"].completion = { code : "SUCCESS"};

                otacModule.CACHED.contacts = otacModule.CACHED.contacts || {};

                otacModule.CACHED.contacts.TEMPLATE_DATA = {
                    totalContacts : 1,
                    contacts : [ { label : selectedContactValue, value: selectedContactEncrypted} ],
                    contactType : deliveryMethod
                }






                self.prepareContactScreen(otacModule.clientParams["helper-data"]);
                return self.sendCodeSuccessHandler(otacModule.clientParams["helper-data"], deliveryMethod);
            }

            otacModule.clientParams["confirm-before-close"] = _.get(e, "data.confirm-before-close", otacModule.clientParams["confirm-before-close"]);
            otacModule.clientParams["confirmation-content"] = _.get(e, "data.confirmation-content", otacModule.clientParams["confirmation-content"]);

            self.fetchAndShowContacts(e);

        });


        self.subscribeEvent(otacModule.EVENTS.OTP_FINALIZE,() => {
            self._finalize(self);
        });

        if (self._isModal() || self._isUCI()) {
            self.subscribeEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_SUCCESS, () => {
                self.closeOtacModal(self, $, otacModule);

            });
        }


        otacModule.Events.sub("MODAL_CLOSE.spartaUILayersUtility", function(e) {
            if (_.get(e, "data.contentId") === otacModule.modalWindowContentID) {
                $("[id*=ah-otp-widget-modalwindow-]").remove();
                otacModule.$moduleModalWindowContext = null;
            }
        });

        otacModule.Events.sub("MODAL_OPENED.spartaUILayersUtility", function(e) {
            if (_.get(e, "data.contentId") === otacModule.modalWindowContentID) {

                otacModule.$moduleModalWindowContext = $(`.${otacModule.modalWindowClass}`);
                self.bindEventHandlers(self.getContext());
                self._fixInputsForMultiOtac();
                otacModule.$moduleModalWindowContext.spartaInputs({
                    validate: true
                });


                otacModule.websessionClearRequired = true;
                if (self._isStandAlone()) {
                    self
                        .getContext()
                        .find(otacModule.SECTIONS.HEAD.OTP)
                        .addClass("skin-standalone");
                }

                if (typeof cX === "function") {
                    cX("onload");
                }

                self.setDefaultFocus(self.getContext());
            }
        });


        otacModule.Events.sub(self.cawEventsMaster.EVENTS.WIDGET_LOAD_SUCCESS, e => {
            otacModule.cawData = e.data;
            if (self._isCAW()                                                           ) {
                const $jContext = self.getContext();
                $jContext.find(".btn-cancel").remove(); 
            }
            if (otacModule.clientParams && otacModule.clientParams.publishNS) {
                otacModule.Events.pub("AH_UNIVERSAL_CAWOTP_READY", { 'otac-namespace': otacModule["events-namespace"].replace(':', '') });
            }
        });

        self.subscribeEvent(otacModule.EVENTS.OTP_REQUEST_CONFIRM_CANCEL, () => {
            self.confirmBeforeClose();
        });
        self.subscribeEvent(otacModule.EVENTS.OTP_ENTRY_CONFIRM_CANCEL, () => {
            self.confirmBeforeClose();
        });

        return self;
    }





    bindEventHandlers($jContext) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;

        if (!$jContext) {
            $jContext = self.getContext();
        }


















        $jContext.on("click.enableSendOTP", `input[name=${otacModule.otpRadioName}]`, () => {
            $jContext.find(`#send-otp-code,${otacModule.LINK.SEND_OTP_CODE}`).removeAttr("disabled");
        });

        $jContext.find(`${otacModule.INPUT.ACTUAL.CVV},${otacModule.INPUT.ACTUAL.EXPIRY_DATE},${otacModule.INPUT.ACTUAL.DEBIT_PIN}, ${otacModule.INPUT.ACTUAL.OTP_CODE}`)
            .on("keyup.enableValidateOTP" , () => {
                const authCode = $jContext.find(otacModule.INPUT.ACTUAL.OTP_CODE).val();
                if((!$jContext.find(".js-card-credit").hasClass("hide")&&
                    $jContext.find(otacModule.INPUT.ACTUAL.CVV).val().length>0 &&
                    $jContext.find(otacModule.INPUT.ACTUAL.EXPIRY_DATE).val().length>0 &&
                    authCode.length>0)||
                    (!$jContext.find(".js-card-debit").hasClass("hide") &&
                        $jContext.find(otacModule.INPUT.ACTUAL.DEBIT_PIN).val().length>0 &&
                        authCode.length>0 ) ||
                    ($jContext.find(".js-card-credit").hasClass("hide") &&
                        $jContext.find(".js-card-debit").hasClass("hide") && authCode.length>0) ){
                    $jContext.find(self._isTokenization()? `#submit-otp-code`:`#validate-otp-code`).removeAttr("disabled");
                }else {
                    $jContext.find(self._isTokenization()? `#submit-otp-code`:`#validate-otp-code`).attr('disabled','disabled');
                }

            });



        $jContext
            .find("input:not(:button)")
            .off("keyup.handleReturnAuth")
            .on("keyup.handleReturnAuth", e => {
                let keyVal = e.which || e.keyCode;
                if (keyVal === 13) {
                    if ($jContext.find("[default-button]:visible").length === 1) {
                        $jContext.find("[default-button]:visible").click();
                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    }
                }
            });

        $jContext.on("keyup.formatMMYY", otacModule.INPUT.ACTUAL.EXPIRY_DATE, function(e) {
            const prevValue = $jContext.find(otacModule.INPUT.ACTUAL.EXPIRY_DATE).data('prev-val');
            const curValue = $(this).val();

            if (prevValue && prevValue !== curValue && prevValue.length < curValue.length &&
                curValue.length === 2 && curValue.indexOf("/") === -1) {
                $(this).val($(this).val() + "/");
            } else if (curValue.length > 2 && curValue.indexOf("/") === -1) {
                $(this).val(`${curValue.substr(0, 2)}/${curValue.substr(2)}`);
            }

            $jContext.find(otacModule.INPUT.ACTUAL.EXPIRY_DATE).data('prev-val', $(this).val());
        });


        $jContext
            .find(`#send-otp-code, .btn-send-otp, ${otacModule.LINK.SEND_OTP_CODE}`)
            .off("click.submitSelectedContact")
            .on("click.submitSelectedContact", () => {

                if (typeof cdApi !== "undefined") {
                    cdApi.changeContext("login-widget:OCA1-OTAC-Enter");
                }












                if (self._isTokenization() && $jContext.find(`#send-otp-code, ${otacModule.LINK.SEND_OTP_CODE}`).prop("disabled") === true) {
                    return true;
                }

                self.submitSelectedContactForOTP();
            });





        $jContext
            .find(`#validate-otp-code, #submit-otp-code, ${otacModule.LINK.VALIDATE_OTP_CODE}, ${otacModule.LINK.TW_VALIDATE_OTP_CODE}`)
            .off("click.submitOTP")
            .on("click.submitOTP", () => {
                if (typeof cdApi !== "undefined") {
                    cdApi.changeContext("login-widget:OCA1-SP-Rememberdevice");
                        } 
                self.validateOTP();
            });

        $jContext
            .find(".btn-cancel")
            .off("click.closeModalPopup")
            .on("click.closeModalPopup", () => {

                if (!otacModule.clientParams["confirm-before-close"]) {

                    self.closeOtacModal(self, $, otacModule);
                }
            });


        $jContext
            .find(".btn-accept-close")
            .off("click.closeModalPopup")
            .on("click.closeModalPopup", () => {
                self.closeOtacModal(self, $, otacModule);
                self.publishEvent(otacModule.EVENTS.OTP_REQUEST_CANCEL);
            });
        $jContext
            .find(".btn-deny-close")
            .off("click.showRecentActiveStep")
            .on("click.showRecentActiveStep", () => {

                self.showStep(otacModule.recentActiveStep);
            });

        $jContext
            .find(".btn-cancel")
            .off("click.publishcancelotp")
            .on("click.publishcancelotp", e => {
                let btnId = e.target.id;
                let cancelEventRequestOTP = otacModule.EVENTS.OTP_REQUEST_CANCEL;
                let cancelEventEntryOTP = otacModule.EVENTS.OTP_ENTRY_CANCEL;

                if (self._isUCI() && otacModule.clientParams["confirm-before-close"]) {
                    cancelEventRequestOTP = otacModule.EVENTS.OTP_REQUEST_CONFIRM_CANCEL;
                    cancelEventEntryOTP = otacModule.EVENTS.OTP_ENTRY_CONFIRM_CANCEL;
                }
                if (btnId === "cancel-request-otp") {
                    self.publishEvent(cancelEventRequestOTP);
                } else if (btnId === "cancel-entry-otp") {
                    self.publishEvent(cancelEventEntryOTP);
                } else if (btnId === "cancel-request-otp-uci" || btnId === "cancel-validate-otp") {


                    self.publishEvent(cancelEventRequestOTP);
                }


                if (self._isTokenization()) {
                    let eventCode = "";
                    if (btnId === "cancel-request-otp") {
                        eventCode = "21130";
                    } else if (btnId === "cancel-entry-otp") {
                        eventCode = "21140";
                    }

                }
            });

        $jContext
            .off("click.alreadyhaveAuth", `#already-have-auth,${otacModule.LINK.ALREADY_HAVE_AUTH},.${otacModule.LINK.ALREADY_HAVE_AUTH_CLASS},.${otacModule.LINK.TW_ALREADY_HAVE_AUTH}`)
            .on(
                "click.alreadyhaveAuth",
                `#already-have-auth,${otacModule.LINK.ALREADY_HAVE_AUTH},.${otacModule.LINK.ALREADY_HAVE_AUTH_CLASS},.${otacModule.LINK.TW_ALREADY_HAVE_AUTH}`,
                e => {
                    e.stopPropagation();
                    e.preventDefault();
                    self.alreadyHaveAuthCode();
                    return false;
                }
            );

        $jContext.on("click.requestAnotherCode", ".acw-request-auth-num,.otp-request-auth-code", e => {
            e.stopPropagation();
            e.preventDefault();
            $("[id*=ah-otp-widget-modalwindow-]").remove();
            otacModule.$moduleModalWindowContext = null;

            if (!self._isStandAlone()) {
                if (self._isTokenization()) {
                    $("#ah-authcode-error-target-1").empty();
                } else if (self._isCAW()) {
                    $("#ah-authcode-error-target-caw").empty();
                }
            }


            self.fetchAndShowContacts({ reRequestAuthCode: true });
            return false;
        });

        $jContext.on("click.showEmailContacts", otacModule.LINK.SHOW_EMAIL_CONTACTS, e => {
            e.stopPropagation();
            e.preventDefault();




            if (!self._isStandAlone()) {
                if (self._isTokenization()) {
                    $("#ah-authcode-error-target-1").empty();
                } else if (self._isCAW()) {
                    $("#ah-authcode-error-target-caw").empty();
                }
            }

            self.fetchAndShowContacts({ showEmailContacts: true });
            return false;
        });

        $jContext.on("click.troubleWithEmail", otacModule.LINK.TROUBLE_WITH_EMAIL, e => {
            e.stopPropagation();
            e.preventDefault();

            self.hideAllErrors();
            self.clearAllFields();

            self.fetchAndShowContacts({ troubleWithEmail: true });

            if (otacModule.clientParams["showNoContactStepup"]) {
                self.showNoContactsStep();
            }
            return false;
        });









        $jContext
            .find("#request-another-code")
            .off("click.requestAnotherCode")
            .on("click.requestAnotherCode", e => {
                e.stopPropagation();
                e.preventDefault();






                if (!self._isStandAlone()) {
                    if (self._isTokenization()) {
                        $("#ah-authcode-error-target-1").empty();
                    } else if (self._isCAW()) {
                        $("#ah-authcode-error-target-caw").empty();
                    }
                }
                if (typeof spaParams !== 'undefined' && spaParams.siteName === "secure-ah-enroll") {
                    $('#ah-enroll-email-container').removeClass('hidden');
                    $("input[type=text]").val("");
                    $('#ah-enroll-email-error-target').addClass('hidden');
                    $('#ah-authcode-container').addClass('hidden');
                }
                else{
                    self.fetchAndShowContacts({ reRequestAuthCode: true });
                }
                return false;
            });


        $jContext
            .find(".spa-input-label")
            .off("click.focusInput")
            .on("click.focusInput", function() {
                const $this = $(this);
                $this.find(" ~ input[type=text]").focus();
            });


        $jContext
            .find("#generic-error-request-authcode-close, #generic-error-enter-authcode-close")
            .off("click")
            .on("click", e => {
                window.location.href = "/login/rest/sas/sparta/secure/v1/oauthRedirect?action=Cancel";
            });

        $jContext
            .find(`#cq-fallback-link`)
            .off("click.cqFallbackLink")
            .on("click.cqFallbackLink", e => {
                e.stopPropagation();
                e.preventDefault();

                self._timedHideContainer();
                let data= {};
                if (_.get(otacModule, "clientParams.passThroughPayload")) {
                    data.passThroughPayload = otacModule.clientParams.passThroughPayload;
                }
                self.publishEvent(otacModule.EVENTS.OTP_FALLBACK_CQ, data);
            });

        if(otacModule.$moduleModalWindowContext && otacModule.$moduleModalWindowContext.length > 0) {
            let modalId = otacModule.$moduleModalWindowContext[0].id;
            let modalIdPrefix = modalId.substring(0, modalId.lastIndexOf('-'));
            let $closeImageButton = $jContext.find("[id*=" + modalIdPrefix + "-SpartaUILayerClose]");
            if($closeImageButton.length > 0) {
                $closeImageButton
                    .off('click.cancel-otp-modal')
                    .on('click.cancel-otp-modal', (event) => {
                            self.publishEvent(otacModule.EVENTS.OTP_REQUEST_CANCEL);
                        }
                    );
            }
        }

        otacModule.$moduleContext = $(otacModule.settings.target);
        const moduleContext = otacModule.$moduleContext;
        const inputSettings = {
            validate: true
        };

        self._fixInputsForMultiOtac();
        moduleContext.spartaInputs(inputSettings);


        const oFormValidations = {};
        const sValidationDataAttr = "data-validation-rules";
        $jContext.find(`[${sValidationDataAttr}]`).each(function() {
            const $this = $(this);
            oFormValidations[$this.attr("id")] = $this.data("validation-rules");
            $this.removeAttr(sValidationDataAttr);
        });
        self.spartaValidationFramework.fn.core.bindValidationRules(oFormValidations, true);

        return self;
    }



    bindThisContext() {
        this.cawCommons.bindThisContext(
            [
                "fetchAndShowContacts",
                "authInitialize",
                "prepareContactScreen",
                "openRequestOTPModalLayer",
                "handleError",
                "hideAllErrors",
                "prepareUCIContactScreen",
                "prepareInitialOTPWidget",
                "getModalContentWrapper",
                "_hideAll",
                "_errorInline",
                "_finalize",
                "validateOTP",
                "confirmBeforeClose",
                "_populateContactsForUI",
                "sendCodeSuccessHandler",
                "clearAllFields",
                "prepareContactScreenForCAW",
                "showFirstScreen",
                "showNoContactsStep"
            ],
            this,
            ""
        );

        return this;
    }




    whatAmI() {


    }






    fetchAndShowContacts(data) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;

        if (otacModule.getContactsInProcess) {
            return;
        }
        otacModule.getContactsInProcess = true;
        otacModule.validateOTPInProcess = false;
        otacModule.sendOTPInProcess = false;

        self.hideAllErrors();

        let paramForAuthInit = {};
        if (data.reRequestAuthCode === true) {
            paramForAuthInit = { reason: "RA" };

        } else if (data && data.data) {
            paramForAuthInit = data.data;
        }
        if (data && data.showEmailContacts) {
            paramForAuthInit.showEmailContacts = true;
        }
        if (data && data.troubleWithEmail) {
            paramForAuthInit.troubleWithEmail = true;
        }

        if (self._isModal()) {

            self
                .authInitialize(paramForAuthInit)
                .then((jData) => {
                    self.prepareContactScreen(jData, data.data);
                })
                .then(self.openRequestOTPModalLayer)



                .fail(self.handleError);
        } else if (self._isUCI()) {
            otacModule._data.UCI = data;

            self
                .prepareUCIContactScreen(data)
                .then(self.openRequestOTPModalLayer)



                .fail(self.handleError);
        } else if (self._isPage()) {











            self
                .authInitialize(paramForAuthInit)
                .then((jData) => {
                    self.prepareContactScreen(jData, data.data);
                })



                .fail(self.handleError);
        } else {
            otacModule._debug("Invalid Widget type");
        }
    }

    authInitialize(data) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        const deferred = $.Deferred();

        if( _.includes( otacModule.STEPS_TO_SKIP, otacModule.STEPS.STEP_INITIATE_STEPUP ) ){

            self._processAjaxSuccess($, otacModule.clientParams["helper-data"], otacModule, _, self, deferred);
            otacModule.STEPS_TO_SKIP = [];
            return deferred.promise();
        }

        let authInitURL = otacModule.apiEndPoints.authCodeInitialize;


        authInitURL = self.getUrl("stepup");
        if (_.get(data, "reason") === "RA") {

            authInitURL = authInitURL + "?isRequestAnotherCode=true";
        }

        let params = self._getDefaultParams("stepup");
        self._addEventProvider(_.get(otacModule, "clientParams.pageID" ), params.processRules );


        if (
            _.get(otacModule, "clientParams.origin") === "signin" || _.get(otacModule, "clientParams.origin") === "olbStandalone" ||
            (_.get(data, "forcedOtp") === "true" || _.get(data, "forcedOtp") === true) ||
            (_.get(otacModule, "clientParams.forcedOtp") === "true" || _.get(otacModule, "clientParams.forcedOtp") === true)
        ) {

            params.stepUpToken = {
                stepUpType: "OTP"
            };
        }

        if (_.get(data, "showEmailContacts")) {
            params.restrictToDeliveryMethod = "EMAIL";
        } else if (_.get(data, "troubleWithEmail")) {
            params.restrictToDeliveryMethod = "CCENTER";
        } else if (_.get(otacModule, "clientParams.restrictMTG") === true) {
            params.restrictToDeliveryMethod = "MTG_FB";
        }

        if (data && data.data) {
            $.extend(true, params, data.data);
        }

        if (data) {
            $.extend(true, params, data);
        }
        delete params.data;

        otacModule.CACHED.contacts = {}; 
        otacModule.CACHED.cardInfo = {}; 
        if (document.location.href.indexOf("mock=true") === -1) {
            $.ajax({
                method: "POST",
                data: JSON.stringify(params),
                url: authInitURL,
                dataType: "text",
                crossDomain: true,
                cache: false,
                timeout: 60000,
                processData: true,
                headers: {
                    "content-type": "application/json",
                    accept: "application/json",
                    "cache-control": "no-cache"
                },
                xhrFields: {
                    withCredentials: true
                },
                complete(data, status, jqXHR) {},
                success(data, status, jqXHR) {
                    let jData;
                    jData = $.parseJSON(data);
                    self._processAjaxSuccess($, jData, otacModule, _, self, deferred);
                },
                error(data, status, jqXHR) {

                    deferred.reject({
                        errorType: otacModule.EVENTS.OTP_INITIATE_FAIL,
                        data
                    });
                }
            });
            return deferred.promise();
        } else {

            let jData = JSON.parse(localStorage.getItem(otacModule.queryParams.get("stepup")));
            if (params.restrictToDeliveryMethod === "EMAIL") {
                jData = JSON.parse(localStorage.getItem(otacModule.queryParams.get("stepup-email")));
            }

            if (jData.errorInfo && jData.errorInfo.length > 0) {
                deferred.reject({
                    errorType: otacModule.EVENTS.OTP_INITIATE_FAIL,
                    data: jData
                });
            } else {
                deferred.resolve(jData);
            }

            return deferred.promise();
        }
    }

    _processAjaxSuccess($, jData, otacModule, _, self, deferred) {
        otacModule.getContactsInProcess = false;

        if (
            /^(OTP|OTP_VERIFY_CVV|OTP_VERIFY_PIN)$/.test(_.get(jData, "stepUpToken.stepUpType")) &&
            jData.stepUpSecuredContactPoints &&
            $.isArray(jData.stepUpSecuredContactPoints) &&
            jData.stepUpSecuredContactPoints.length > 0
        ) {

            self.publishEvent(otacModule.EVENTS.AUTH_INITIATE_STEPUP_COMPLETE);
            self.publishEvent(otacModule.EVENTS.AUTH_INITIATE_STEPUP_SUCCESS);
            deferred.resolve(jData);
        } else if (_.get(jData, "stepUpToken.stepUpType") === "NONE") {
            self.publishEvent(otacModule.EVENTS.AUTH_INITIATE_STEPUP_COMPLETE);
            self.publishEvent(otacModule.EVENTS.OTP_NOT_REQUIRED, jData.stepUpToken.tokenSets[0].value.text);

            deferred.reject({
                errorType: otacModule.EVENTS.OTP_NOT_REQUIRED,
                data: jData,
                isSoftError: true
            });
        } else if (_.get(jData, "stepUpToken.stepUpType") === "DEBIT_CARD" || _.get(jData, "stepUpToken.stepUpType") === "DEBIT_CARD_PIN" || _.get(jData, "stepUpToken.stepUpType") === "CREDIT_CARD") {
            otacModule.Store.addData('CARDINFO', jData);
            self.publishEvent('AH_ACCT_SSN_COMPLETE', jData);
        } else {
            self.publishEvent(otacModule.EVENTS.AUTH_INITIATE_STEPUP_COMPLETE);
            self.publishEvent(otacModule.EVENTS.AUTH_INITIATE_STEPUP_FAIL);

            deferred.reject({
                errorType: otacModule.EVENTS.OTP_INITIATE_FAIL,
                data: jData
            });
        }
    }





    prepareContactScreen(jData, inputData) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        let deferred = $.Deferred(),
            $jContext = self.getContext();

        if (self._isModal() || self._isUCI()) {
            self.prepareInitialOTPWidget();
        }

        if(_.get(inputData, "passThroughError")) {
            self._errorInline(inputData.passThroughError.title, inputData.passThroughError.message, inputData.passThroughError.type);
        }








        let customerContacts = []; 
        let contactType = ""; 
        let isIVRDown = true;





        $jContext.find("#phoneList").html("");
        $jContext.find("#emailList").html("");

        if (jData.stepUpSecuredContactPoints && $.isArray(jData.stepUpSecuredContactPoints) && jData.stepUpSecuredContactPoints.length > 0) {
            let i = 0;
            for (i = 0; i < jData.stepUpSecuredContactPoints.length; i++) {
                const currentContact = {};
                currentContact.inputName = otacModule.otpRadioName;
                currentContact.id = `${jData.stepUpSecuredContactPoints[i].deliveryMethod}${i + 1}`;
                currentContact.value = jData.stepUpSecuredContactPoints[i].encryptedContactPoint.value;
                currentContact.label = jData.stepUpSecuredContactPoints[i].maskedContactPoint.value;

                if (jData.stepUpSecuredContactPoints[i].deliveryMethod === "EMAIL") {
                    contactType = "email";
                    currentContact.labelToDisplay = currentContact.label;
                    customerContacts.push(currentContact);
                } else if (jData.stepUpSecuredContactPoints[i].deliveryMethod === "TEXT") {
                    contactType = "phone";
                    currentContact.labelToDisplay = currentContact.label.replace(/\*/g, "x");
                    customerContacts.push(currentContact);
                } else if (jData.stepUpSecuredContactPoints[i].deliveryMethod === "VOICE") {
                    isIVRDown = false;
                }
            }


            otacModule.CACHED.contacts = {};
            otacModule.CACHED.cardInfo = {};
            if (jData.cardIdentifierList && $.isArray(jData.cardIdentifierList) && jData.cardIdentifierList.length > 0) {




                otacModule.CACHED.cardInfo = jData.cardIdentifierList;
            }
            this._populateContactsForUI(contactType, customerContacts, isIVRDown);
        }

        self.cawCommons._hideAll(otacModule.SECTIONS.HEAD, $jContext);
        self.cawCommons._hideAll(otacModule.SECTIONS.OTP, $jContext);

        self.cawCommons._show(otacModule.SECTIONS.HEAD.OTP, $jContext);
        if (self.isModalAlreadyOpened()) {
            self.cawCommons._show(otacModule.SECTIONS.HEAD.MODAL_CONTENT, $jContext);
            self.cawCommons._show(otacModule.SECTIONS.OTP.REQUEST_OTP, $jContext);
        }

        if (self._isPage()) {
            self.cawCommons._show(otacModule.SECTIONS.OTP.REQUEST_OTP, $jContext);
        }


        if (!self._isStandAlone()) {

            if (self._isTokenization()) {
                self.prepareContactScreenForTokenization();
            } else if (self._isCAW()) {

                self.prepareContactScreenForCAW(inputData);
            }
        }

        if (customerContacts.length === 1) {
            $jContext.find(`#send-otp-code, ${otacModule.LINK.SEND_OTP_CODE}`).prop("disabled", false);
        } else {
            $jContext.find(`#send-otp-code, ${otacModule.LINK.SEND_OTP_CODE}`).prop("disabled", true);
        }


        otacModule.getContactsInProcess = false;
        window.setTimeout(() => {
            deferred.resolve();
        }, 100);
        return deferred.promise();
    }


    prepareContactScreenForCAW(inputData) {
        const self = this;
        const $ = this.$;
        const otacModule = this.parentModule;

        const $jContext = self.getContext();

        $jContext
            .find("#requestAuthStep")
            .find(".authcode-tokenization")
            .addClass("hidden");

        $jContext
            .find("#requestAuthStep")
            .find(".authcode-caw")
            .removeClass("hidden");


        let indicatorArray = _.get(inputData, "authenticationIndicators");
        if (indicatorArray && Array.isArray(indicatorArray) && indicatorArray.length > 0) {
            inputData.authenticationIndicatorsMap = {};
            _.get(indicatorArray.forEach(function (item, index) {
                if(typeof _.get(item, "name") === 'undefined' || typeof _.get(item, "indicator") === 'undefined') {
                    otacModule._debug("skipping indicator due to bad format");
                } else {
                    inputData.authenticationIndicatorsMap[_.get(item, "name")] = _.get(item, "indicator");
                }
            }));
        }


        if (_.get(inputData, "authenticationIndicatorsMap.displayCQRetdInfo")) {
            $jContext
                .find("#requestAuthStep")
                .find(".authcode-caw.js-cqcontext")
                .attr('aria-hidden','false').removeClass("hide");

            this._setupImportantTitle($jContext);

            if (_.get(inputData, "authenticationIndicatorsMap.displayCQFallbackLink")) {
                $jContext
                    .find("#requestAuthStep")
                    .find(".authcode-caw.js-cqcontext-actionable")
                    .attr('aria-hidden','false').removeClass("hide");
            } else {
                $jContext
                    .find("#requestAuthStep")
                    .find(".authcode-caw.js-cqcontext-actionable")
                    .attr('aria-hidden','true').addClass("hide");
            }
        } else {
            $jContext
                .find("#requestAuthStep")
                .find(".authcode-caw.js-cqcontext")
                .attr('aria-hidden','true').addClass("hide");

            $jContext
                .find("#requestAuthStep")
                .find(".authcode-caw.js-cqcontext-actionable")
                .attr('aria-hidden','true').addClass("hide");
        }


        $jContext
            .find("#requestAuthStep")
            .find(".authcode-all")
            .removeClass("hidden");

        $jContext
            .find("#otp-request-tw-buttons a")
            .removeClass("spa-btn--large")
            .addClass("spa-btn--small");

        $jContext
            .find("#contactPhonesWrapper .otp-caw-text-ensure")
            .addClass("title-help")
            .removeClass("hidden");

        $jContext
            .find("#phoneList")
            .find("label")
            .removeClass("tw-spa-input-option-label");

        $jContext
            .find("#emailList")
            .find("label")
            .removeClass("tw-spa-input-option-label");

        $jContext
            .find("#emailList")
            .addClass("mb-30")
            .removeClass("mb-40");
    }



    prepareContactScreenForTokenization() {
        const self = this;
        const $ = this.$;

        const $jContext = self.getContext();

        $jContext
            .find("#requestAuthStep")
            .find(".authcode-tokenization")
            .removeClass("hidden");

        $jContext
            .find("#requestAuthStep")
            .find(".authcode-caw")
            .addClass("hidden");

        $jContext
            .find("#requestAuthStep")
            .find(".authcode-all")
            .removeClass("hidden")

        $jContext
            .find("#otp-request-tw-buttons a")
            .addClass("spa-btn--large")
            .removeClass("spa-btn--small");

        $jContext
            .find("#contactPhonesWrapper .otp-caw-text-ensure")
            .removeClass("title-help")
            .addClass("hidden");

        $jContext.find("#phoneList label, #emailList label").addClass("tw-spa-input-option-label");

        $jContext
            .find("#emailList")
            .removeClass("mb-30")
            .addClass("mb-40");


        $jContext.find("section[id$='caw-buttons']").remove();
    }

    prepareUCIContactScreen(jData) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        let deferred = $.Deferred(),
            $jContext = this.getContext();

        if (self._isModal() || self._isUCI()) {



            self.prepareInitialOTPWidget();
        }

        let contactContext = {},
            $uciRequestOTP = $jContext.find(otacModule.SECTIONS.OTP.UCI_REQUEST_OTP);

        $uciRequestOTP.find(".js-seltype").addClass("hide");
        if (jData.reRequestAuthCode !== true) {

            otacModule._data.OTP.selectedContactType = _.get(jData, "data.contactPoint.type"); 
            let configContactVal = _.get(jData, "data.contactPoint.value");
            if (otacModule.jsEncrypt) {
                otacModule._data.OTP.selectedContact = otacModule.jsEncrypt.encrypt(configContactVal);
            } else {
                if (this.jsEncrypt && this.jsEncrypt.JSEncrypt) {
                    const JSEncrypt = new this.jsEncrypt.JSEncrypt();
                    JSEncrypt.setPublicKey(otacModule.publicKey);
                    otacModule.jsEncrypt = JSEncrypt;

                    otacModule._data.OTP.selectedContact = otacModule.jsEncrypt.encrypt(configContactVal);
                } else {
                    otacModule._debug("Encryption api not available");
                }
            }
            otacModule._data.OTP.selectedMaskedContact = _.get(jData, "data.contactPoint.masked");
        }

        if (otacModule._data.OTP.selectedContactType === "EMAIL" || otacModule._data.OTP.selectedContactType === "TEXT") {
            const selectedContactTypeLower = otacModule._data.OTP.selectedContactType.toLowerCase();
            $uciRequestOTP.find(`.js-seltype-${selectedContactTypeLower}`).removeClass("hide");
            $uciRequestOTP.find(`.js-seltype-${selectedContactTypeLower} .selected-contact`).text(_.get(otacModule, "_data.OTP.selectedMaskedContact"));
        }

        otacModule.recentActiveStep = otacModule.SECTIONS.OTP.UCI_REQUEST_OTP;

        self.showStep(otacModule.SECTIONS.OTP.UCI_REQUEST_OTP);

        otacModule.CACHED.contacts = otacModule.CACHED.contacts || {};


        const uciContact = {};
        uciContact.inputName = otacModule.otpRadioName;
        uciContact.value = _.get(otacModule, "_data.OTP.selectedContact");
        uciContact.label = _.get(otacModule, "_data.OTP.selectedMaskedContact");
        uciContact.labelToDisplay = _.get(otacModule, "_data.OTP.selectedMaskedContact");

        otacModule.CACHED.contacts.TEMPLATE_DATA = {
            contactType: otacModule._data.OTP.selectedContactType.toLowerCase() === "email" ? "email" : "phone",
            isSingleContact: true,
            totalContacts: 1,
            contacts: [uciContact]
        };

        if (otacModule.CACHED.contacts.TEMPLATE_DATA.contactType === "email") {
            otacModule.CACHED.contacts.TEMPLATE_DATA.isEmailContact = true;
            otacModule.CACHED.contacts.TEMPLATE_DATA["contact-label"] = otacModule.i18n["select-email"];

            otacModule.CACHED.contacts.TEMPLATE_DATA.isPhoneContact = false;
        } else if (otacModule.CACHED.contacts.TEMPLATE_DATA.contactType === "phone") {
            otacModule.CACHED.contacts.TEMPLATE_DATA.isPhoneContact = true;
            otacModule.CACHED.contacts.TEMPLATE_DATA["contact-label"] = otacModule.i18n["select-phone"];

            otacModule.CACHED.contacts.TEMPLATE_DATA.isEmailContact = false;
        }

        otacModule.getContactsInProcess = false;
        window.setTimeout(() => {
            deferred.resolve();
        }, 100);

        return deferred.promise();
    }

    prepareInitialOTPWidget() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        if (self._isModal() || self._isUCI()) {

            otacModule.CACHED._WidgetContainerRoot.find(otacModule.otpWidgetSectionID).remove();
            if (self._isUCI() || (self._isModal() && !self.isModalAlreadyOpened())) {

                otacModule.CACHED._WidgetContainerRoot.append(otacModule.CACHED._OtpWidgetInitialDom.clone().addClass("hide"));
            }

            if ($(otacModule.clientParams["confirmation-content"]).length === 1) {
                self
                    .getContext()
                    .find(otacModule.SECTIONS.OTP.CONFIRM_BEFORE_CLOSE + " .confirm-message")
                    .html($(otacModule.clientParams["confirmation-content"]).html())
                    .removeClass("hidden");
            }
        }
    }

    openRequestOTPModalLayer() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        const $modalContentWrapper = self.getModalContentWrapper();

        if (self.isModalAlreadyOpened()) {


            otacModule.recentActiveStep = otacModule.SECTIONS.OTP.REQUEST_OTP;
            self.showFirstScreen(self.getContext());
            self.cawCommons._show(otacModule.SECTIONS.HEAD.MODAL_CONTENT, self.getContext());
        } else {
            $modalContentWrapper.append(
                otacModule.CACHED._WidgetContainerRoot
                    .find("> .ah-otp-widget")
                    .clone()
                    .removeClass("hide")
            );

            const options = {
                type: "modal",
                closeOnEscape: false,
                optionalClasses: otacModule.modalWindowClass,
                contentId: otacModule.modalWindowContentID,
                width: "500"
            };
            if (self._isUCI()) {
                options.width = "656";

                if (otacModule.clientParams["confirm-before-close"]) {
                    options.closeButton = false;
                }
            }
            $modalContentWrapper.data("options", options);




            otacModule.CACHED._WidgetContainerRoot.find(`> ${otacModule.otpWidgetSectionID}`).remove(); 
            self.showFirstScreen($modalContentWrapper);

            otacModule._debug(`Modal Layer content found: ${$modalContentWrapper.find(".content").length === 0 ? "NO" : "YES"}`);
            self.spartaUILayersUtility.openLayer($modalContentWrapper);
        }
    }

    openErrorModalLayer() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        const $modalContentWrapper = self.getModalContentWrapper();
        if (otacModule.CACHED._WidgetContainerRoot.find(".content").length === 0) {
            self.prepareInitialOTPWidget();
        }

        $modalContentWrapper.append(
            otacModule.CACHED._WidgetContainerRoot
                .find("> .ah-otp-widget")
                .clone()
                .removeClass("hide")
        );

        const options = {
            type: "modal",
            closeOnEscape: false,
            optionalClasses: otacModule.modalWindowClass,
            contentId: otacModule.modalWindowContentID,
            width: "666"
        };
        if (self._isUCI()) {
            options.width = "656";
        }
        $modalContentWrapper.data("options", options);

        self.cawCommons._hideAll(otacModule.SECTIONS.OTP, $modalContentWrapper);

        otacModule._debug(`Modal Layer content found: ${$modalContentWrapper.find(".content").length === 0 ? "NO" : "YES"}`);
        self.spartaUILayersUtility.openLayer($modalContentWrapper);
    }

    hideAllErrors() {
        let $jContext = this.getContext();
        const $ = this.$;


        $jContext.find(".errors-wrapper").addClass("hide");
        $jContext.find("#ah-authcode-error-target-caw").empty();
        $jContext.find("#ah-authcode-error-target-caw,#ah-authcode-error-target-1,#ah-authcode-error-target-2,#global-auth-error").empty();


        $jContext.find("[data-validation]:visible").each(function() {
            $(this).removeClass('spa-error-form-input--validation');
            $(this).siblings('label').removeClass('spa-error-form-label--validation');
        });
        $jContext.find("input[name=cardsSelect]:visible").parents('#cardsRadio').find('> label').removeClass('spa-error-form-label--validation');

    }

    clearAllFields(screenCode) {
        const $jContext = this.getContext();
        const otacModule = this.parentModule;



        _.forOwn(otacModule.INPUT.ACTUAL, function(inputId, key) {
            $jContext.find(inputId).val('');
        });

        $jContext.find("#numberedOTPThroughPhoneHeader").addClass("hide");
        $jContext.find("#numberedOTPThroughEmailHeader").addClass("hide");


    }




    submitSelectedContactForOTP() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        const $jContext = this.getContext();

        if (otacModule.sendOTPInProcess) {
            return;
        }

        otacModule.sendOTPInProcess = true;
        self.hideAllErrors();
        self.publishEvent(otacModule.EVENTS.OTP_SEND_CODE);

        let selectedContactVal = "",
            selectedContactType = "",
            selectedContactLabel = "",
            action = "";

        if (self._isUCI()) {
            selectedContactVal = otacModule._data.OTP.selectedContact;
            selectedContactType = otacModule._data.OTP.selectedContactType;
            selectedContactLabel = otacModule._data.OTP.selectedMaskedContact;
        } else if (self._isPage() || self._isModal()) {
            otacModule.CACHED.SELECTED_CONTACT = self.getSelectedContactData();
            selectedContactLabel = otacModule.CACHED.SELECTED_CONTACT.label;
            selectedContactType = otacModule.CACHED.SELECTED_CONTACT.type;
            selectedContactVal = otacModule.CACHED.SELECTED_CONTACT.value;
        }

        let sendAuthCodeURL = self.getUrl("sendCode");
        let defaultParams = self._getDefaultParams("sendCode");
        self._addEventProvider(_.get(otacModule, "clientParams.pageID" ), defaultParams.processRules );

        const requestData = defaultParams;

        requestData.securedContactPoint.maskedContactPoint.value = selectedContactLabel;
        requestData.securedContactPoint.encryptedContactPoint.value = selectedContactVal;
        requestData.securedContactPoint.deliveryMethod = selectedContactType;

        requestData.processRules[_.findLastIndex(requestData.processRules, { name: 'Profile' })].value = otacModule.clientParams.customerProfile ? otacModule.clientParams.customerProfile : "A01";

        if (document.location.href.indexOf("mock=true") !== -1) {
            const jData = JSON.parse(localStorage.getItem(otacModule.queryParams.get("sendcode")));
            self.sendCodeSuccessHandler(jData, selectedContactType);
            return;
        }

        $.ajax({
            method: "POST",
            data: JSON.stringify(requestData),
            url: sendAuthCodeURL,
            dataType: "text",
            crossDomain: true,
            cache: false,
            timeout: 60000,
            processData: true,
            headers: {
                "content-type": "application/json",
                accept: "application/json",
                "cache-control": "no-cache"
            },
            xhrFields: {
                withCredentials: true
            },
            complete(data, status, jqXHR) {
                otacModule.sendOTPInProcess = false;
            },
            success(data, status, jqXHR) {
                const jData = $.parseJSON(data);



                self.sendCodeSuccessHandler(jData, selectedContactType);
            },
            error(data, status, jqXHR) {







                otacModule.sendOTPInProcess = false;
                self.handleError({
                    errorType: otacModule.EVENTS.OTP_SEND_CODE_FAILURE,
                    data
                });
            }
        });
    }

    validateOTP() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        let $jContext = self.getContext();

        if (otacModule.validateOTPInProcess) {
            return;
        }


        self.hideAllErrors();

        otacModule.validateOTPInProcess = true;
        self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE);

        const isBasicValidationSuccess = self.validateFields("enter-auth");
        if (!isBasicValidationSuccess) {
            otacModule.validateOTPInProcess = false;
            return;
        }

        let validateAuthCodeURL = self.getUrl("validateCode");
        let defaultParams = self._getDefaultParams("validateCode");
        self._addEventProvider(_.get(otacModule, "clientParams.pageID" ), defaultParams.processRules );

        const requestData = defaultParams;

        const authCode = $jContext.find(otacModule.INPUT.ACTUAL.OTP_CODE).val();
        requestData.authenticationCode = authCode;
        requestData.processRules[_.findLastIndex(requestData.processRules, { name: 'Profile' })].value = otacModule.clientParams.customerProfile ? otacModule.clientParams.customerProfile : "A01";
        if (otacModule.CACHED.cardInfo && otacModule.CACHED.cardInfo.length > 0) {

            const selectedCard = $jContext.find(`input[name=${otacModule.cardsRadioName}]:checked`);
            if (otacModule.CACHED.cardInfo[0].type.name === "CREDIT") {
                requestData.cardIdentifier = {
                    cardNumber: selectedCard.val(),
                    cvv: $jContext.find(otacModule.INPUT.ACTUAL.CVV).val(),
                    type: { name: "CREDIT" },
                    formattedExpDate: $jContext.find(otacModule.INPUT.ACTUAL.EXPIRY_DATE).val()
                };
            } else if (otacModule.CACHED.cardInfo[0].type.name === "DEBIT") {
                requestData.cardIdentifier = {
                    cardNumber: selectedCard.val(),
                    pin: $jContext.find(otacModule.INPUT.ACTUAL.DEBIT_PIN).val(),
                    type: { name: "DEBIT" }
                };
            }
        }

        $.ajax({
            method: "POST",
            data: JSON.stringify(requestData),
            url: validateAuthCodeURL,
            dataType: "text",
            crossDomain: true,
            cache: false,
            timeout: 60000,
            processData: true,
            headers: {
                "content-type": "application/json",
                accept: "application/json",
                "cache-control": "no-cache"
            },
            xhrFields: {
                withCredentials: true
            },
            complete(data, status, jqXHR) {},
            success(data, status, jqXHR) {
                const jData = $.parseJSON(data);
                self.clearAllFields("enter-otp");

                if (jData && jData.completion && jData.completion.code === "SUCCESS") {
                    if (otacModule.clientParams && otacModule.clientParams.origin && otacModule.clientParams.origin === "signin") {
                        if (!self._isStandAlone()) {
                            let tokenval = null;
                            if (jData.stepUpToken && jData.stepUpToken.value && jData.stepUpToken.value.cipherData && jData.stepUpToken.value.cipherData.value) {
                                tokenval = jData.stepUpToken.value.cipherData.value;
                            }
                            if (self._isTokenization()) {
                                otacModule.$moduleContext.find("#enterAuthStep").addClass("hidden");
                                self.publishEvent(self.cawEventsMaster.EVENTS.TOKENIZATION_OTP_VALIDATE_SUCCESS, tokenval);
                            } else {
                                if (self._isModal() || self._isUCI()) {
                                    self.closeOtacModal(self, $, otacModule);
                                }
                                self.publishEvent(self.cawEventsMaster.EVENTS.OTP_VALIDATE_CODE_SUCCESS, tokenval);
                            }
                        }
                    } else {
                        if (self._isModal() || self._isUCI()) {
                            self.closeOtacModal(self, $, otacModule);
                        }



                        if (_.get(otacModule, "clientParams.flowName") === "non-sm") {
                            self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_SUCCESS, _.get(jData, "stepUpToken.value.cipherData.value"));
                            self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_SUCCESS_RESPONSE, jData);
                        } else {
                            self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_SUCCESS, jData.stepUpToken.value.cipherData.value);
                            self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_SUCCESS_RESPONSE, jData);
                        }
                    }
                } else {
                    self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_FAILURE);
                    self.handleError({
                        errorType: otacModule.EVENTS.OTP_VALIDATE_CODE_FAILURE,
                        data: jData
                    });
                }
                otacModule.validateOTPInProcess = false;
            },
            error(data, status, jqXHR) {
                self.handleError({
                    errorType: otacModule.EVENTS.OTP_VALIDATE_CODE_FAILURE,
                    data
                });
                otacModule.validateOTPInProcess = false;
            }
        });
    }

    alreadyHaveAuthCode() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const $jContext = this.getContext();

        self.publishEvent(otacModule.EVENTS.OTP_HAVE_AUTH_SUCCESS);

        const enterOTPStep = $jContext.find(otacModule.SECTIONS.OTP.ENTER_OTP);
        enterOTPStep.find(".js-seltype, .js-selected-contact").addClass("hide");

        self.clearAllFields("enter-otp");

        enterOTPStep.find(".js-selected-contact").text("");
        enterOTPStep.find(".js-have-auth").removeClass("hide");

        $jContext.find("#ah-authcode-error-target-caw,#ah-authcode-error-target-1,#ah-authcode-error-target-2,#global-auth-error").empty();

        otacModule.recentActiveStep = otacModule.SECTIONS.OTP.ENTER_OTP;

        self.showStep(otacModule.SECTIONS.OTP.ENTER_OTP);
        return;
    }





    getContext() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;

        if ((self._isModal() || self._isUCI()) && otacModule.$moduleModalWindowContext) {
            return otacModule.$moduleModalWindowContext;
        }
        return otacModule.$moduleContext;
    }

    isModalAlreadyOpened() {
        const self = this;
        const otacModule = this.parentModule;
        return (self._isModal() || self._isUCI()) && otacModule.$moduleModalWindowContext;
    }

    getModalContentWrapper() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;

        let $modalContentWrapper = otacModule.$moduleContext.find(otacModule.SECTIONS.HEAD.MODAL_CONTENT);

        if ($modalContentWrapper.length === 0) {
            otacModule.CACHED._WidgetContainerRoot.append(
                $("<div/>")
                    .attr("id", otacModule.modalContentWrapperID)
                    .addClass("hide")
            );
            $modalContentWrapper = otacModule.$moduleContext.find(otacModule.SECTIONS.HEAD.MODAL_CONTENT);
        }
        return $modalContentWrapper;
    }

    getUrl(urlCode) {
        let prefix;
        const otacModule = this.parentModule;
        const host = otacModule.Store.getData('widgetConfigData');




        let apiEndpoints = ( host && host.domain ) ?
            this.cawCommons.getEndPoints(this.constructorParams.apiEndPoints, host.domain) :
            otacModule.apiEndPoints;

        if (otacModule.cawData && otacModule.cawData.usecase === "tokenization") {
            prefix = "tokenize";
        } else if (otacModule.clientParams &&
            (otacModule.clientParams.origin === "signin" || otacModule.clientParams.flowName === "non-sm")
        ) {
            prefix = "nonsm";
        } else if (this._isUCI()) {
            prefix = "uci";
        } else {
            prefix = "default";
        }

        if (urlCode === "stepup" || urlCode === "sendCode" || urlCode === "validateCode") {
            return apiEndpoints[prefix + "-" + urlCode];
        } else {
            otacModule._debug("Incorrect urlCode");
            return "//incorrect urlCode";
        }
    }

    _addEventProvider( pageID, processRules ){
        const otacModule = this.parentModule;
        const _ = this._;
        if (  _.includes(otacModule.PAGE_WITH_SPA_EVENT, pageID ) ){
            processRules.push({'EventProvider':'SPA'});
        }
    }

    _getDefaultParams(urlCode) {
        const otacModule = this.parentModule;

        if (urlCode === "validateCode") {

            if(otacModule.cawData && otacModule.cawData.originatingFrom === "ATP-CAW"){
				return {
                    authenticationCode: "TO-BE-FILLED",
                    processRules: [{
                        name: "SourceChannel",
                        value: "VMA"
                    },
                        {
                            name: "Profile",
                            value: "A01"
                        },
                        {
                            name: "AuthenticationContext",
                            value: "ATPSIGNIN"
                        }
                    ]
				}; 
            } else {
            return {
                authenticationCode: "TO-BE-FILLED",
                processRules: [{
                    name: "SourceChannel",
                    value: "VMA"
                },
                    {
                        name: "Profile",
                        value: "A01"
                    },
                    {
                        name: "AuthenticationContext",
                        value: otacModule.clientParams.pageID
                    }
                ]
            };
        }

        } else if (urlCode === "stepup") {

            if(otacModule.cawData && otacModule.cawData.originatingFrom === "ATP-CAW"){
				return {
				authenticationLevel: { code: "targetAuthLevel", value: "400" },
                processRules: [{ name: "AuthenticationContext", value: "ATPSIGNIN" }]
				}; 
			} else {
            return {
                authenticationLevel: { code: "targetAuthLevel", value: "400" },
                processRules: [{ name: "AuthenticationContext", value: otacModule.clientParams.pageID }]
            };
        }

        } else if (urlCode === "sendCode") {
            if(otacModule.cawData && otacModule.cawData.originatingFrom === "ATP-CAW"){
				return {
                    securedContactPoint: {
                        maskedContactPoint: {
                            value: "TO-BE-FILLED",
                            description: "Masked Phone Number"
                        },
                        encryptedContactPoint: {
                            algorithm: "RSA",
                            value: "TO-BE-FILLED"
                        },
                        deliveryMethod: "TO-BE-FILLED",
                        priority: "high",
                        authenticationType: "AUTHCODE"
                    },
                    processRules: [{
                        name: "SourceChannel",
                        value: "VMA"
                    },
                        {
                            name: "Profile",
                            value: "A01"
                        },
                        {
                            name: "AuthenticationContext",
                            value: "ATPSIGNIN"
                        }
                    ]
				}; 
			} else {

            return {
                securedContactPoint: {
                    maskedContactPoint: {
                        value: "TO-BE-FILLED",
                        description: "Masked Phone Number"
                    },
                    encryptedContactPoint: {
                        algorithm: "RSA",
                        value: "TO-BE-FILLED"
                    },
                    deliveryMethod: "TO-BE-FILLED",
                    priority: "high",
                    authenticationType: "AUTHCODE"
                },
                processRules: [{
                    name: "SourceChannel",
                    value: "VMA"
                },
                    {
                        name: "Profile",
                        value: "A01"
                    },
                    {
                        name: "AuthenticationContext",
                        value: otacModule.clientParams.pageID
                    }
                ]
            };
        }

        }
    }

    handleError(errorObject) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        let $jContext = self.getContext(),
            $errorWrapper;

        if (errorObject && errorObject.isSoftError) {
            otacModule.getContactsInProcess = false;
            return;
        }

        if (errorObject && errorObject.data && errorObject.data.responseText) {
            errorObject.data = $.parseJSON(errorObject.data.responseText);
        }

        if ((self._isModal() || self._isUCI()) && $("[id*=ah-otp-widget-modalwindow-]").length === 0) {

            self.openErrorModalLayer();
            window.setTimeout(() => {
                self.showError(errorObject);
            }, 1000);
        } else {
            self.showError(errorObject);
        }



        if (errorObject && _.get(errorObject, "data.errorInfo.0.code")) {
            self.cawCommons.trackCoreMetricesError("VIPAA_ACW_" + _.get(errorObject, "data.errorInfo.0.code"), _.get(errorObject, "data.errorInfo.0.code"));
        }

        otacModule.getContactsInProcess = false;
    }

    showError(errorObject) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        const $jContext = self.getContext();
        let $errorWrapper = "";

        $errorWrapper = $jContext.find(".errors-wrapper .error").remove();

        if (errorObject && errorObject.data) {
            if (errorObject.data.isFatalError === true) {

                $jContext.find(".js-widget-step").remove();

                $errorWrapper = $jContext.find(".errors-wrapper");

                self.publishEvent(otacModule.EVENTS.OTP_FATAL_ERROR);
            } else {
                $errorWrapper = $jContext.find(".js-widget-step:visible .errors-wrapper");
                if ($errorWrapper.length === 0) {
                    $errorWrapper = $jContext.find(".errors-wrapper");
                }
            }

            let errorCode = _.get(errorObject, "data.errorInfo.0.code");
            if (otacModule && otacModule.cawData && otacModule.cawData.clientId === "ATP") {
                if (errorCode === "E0015" || errorCode === "E0016" || errorCode === "E0017" || errorCode === "E0018" || errorCode === "E0019"){
                    errorCode = "ATP_"+errorCode;
                }

                            }


            if (errorCode === "ERROR_NO_CONTACTS" || errorCode === "E0014") {
                self.showNoContactsStep();
                return;
            }

            let errorDescription;
            if (!self._isStandAlone()) {
                if (self._isTokenization()) {
                    let flowName = otacModule.Store.getData("widgetConfigData");

                    let tempUsecase = flowName.usecase;
                    if (_.includes(otacModule.consentOnScreenErrorCodes, errorCode)) {
                        errorDescription = otacModule.ERRORS[tempUsecase][errorCode];
                    } else {
                        const tokenizationErrorSource = ["MEDG", "MELY", "USTR", "MLIN", "MLBO", "BAML"];
                        let erroCodeKey = "EG";
                        if (flowName.source && _.indexOf(tokenizationErrorSource, flowName.source) != -1) {
                            erroCodeKey = "EG" + flowName.source;
                        }
                        errorDescription = otacModule.ERRORS[tempUsecase][erroCodeKey];

                        if (self._isEnterAuthSectionVisible()) {
                            otacModule.$moduleContext
                                .find(`#otp-entry-input-container, #request-another-code,.authcode-all,.authcode-caw,
                          .js-selected-contact,.js-show-nocontacts,.js-hide-nocontacts,.js-seltype-email,.js-seltype-email,
                          .js-seltype-voice,js-seltype-text`).remove();
                            otacModule.$moduleContext.find("#otp-entry-input-container").remove();
                            otacModule.$moduleContext.find("#request-another-code").removeClass("request-code");
                            otacModule.$moduleContext.find("#generic-error-enter-authcode-section").removeClass("hidden");
                            otacModule.$moduleContext.find("#generic-error-request-authcode-section").addClass("hidden");
                        } else if (self._isRequestAuthSectionVisible()) {
                            otacModule.$moduleContext.find("#contactPhonesWrapper, #contactEmailsWrapper, .authcode-all").addClass("authcode-tokenization hidden");
                            otacModule.$moduleContext.find("#generic-error-enter-authcode-section").addClass("hidden");
                            otacModule.$moduleContext.find("#generic-error-request-authcode-section").removeClass("hidden");
                        }
                        otacModule.$moduleContext.find(".authcode-tokenization").addClass("hidden");
                    }
                    $("#tw-authcode-message-container").addClass("hidden");

                } else {
                    errorDescription = self.getErrorDescription(errorCode);
                }
            }
            if (!errorDescription || _.trim(errorDescription).length === 0) {

                if (errorCode && !errorDescription) {
                    try {
                        errorDescription = self.getErrorDescription(errorCode);







                    } catch (e) {}
                }
            }

            if (errorDescription) {


                if (typeof errorDescription === "object") {
                    self._errorInline(errorDescription.title, errorDescription.message, errorDescription.type);
                    if (errorDescription.type && errorDescription.type === "fatal") {
                        if (typeof spaParams !== 'undefined' && spaParams.siteName === "secure-ah-enroll") {
                            self.cawCommons._hideAll(otacModule.SECTIONS.OTP, $jContext);
                            self.publishEvent(otacModule.EVENTS.OTP_FATAL_ERROR);
                        }
                        else{
                            self.cawCommons._hideAll(otacModule.SECTIONS.OTP, $jContext);
                        }
                    }
                } else {
                    self._errorInline(errorDescription);
                }
            }
        }
    }

    getErrorDescription(errorCode) {
        const self = this;
        const otacModule = this.parentModule;

        let errorDescription = '';


        if (otacModule.CUSTOMERROR && otacModule.CUSTOMERROR.ERROR && otacModule.CUSTOMERROR.ERROR[errorCode]) {
            errorDescription = otacModule.CUSTOMERROR.ERROR[errorCode];
        } else if (otacModule.ERRORS.OTAC && otacModule.ERRORS.OTAC[errorCode]) {
            errorDescription = otacModule.ERRORS.OTAC[errorCode]; 
        } else if (otacModule.ERRORS[errorCode]) {
            errorDescription = otacModule.ERRORS[errorCode];
        } else {

            if (otacModule && otacModule.cawData && otacModule.cawData.clientId === "ATP") {
                errorDescription = otacModule.ERRORS['ATP_ERROR_DEFAULT'];
            } else {
                errorDescription = otacModule.ERRORS['ERROR_DEFAULT'];
            }
        }

        return errorDescription;
    }
    _errorInline(title, content, errorType) {
        if (!content) {
            content = " ";
        }

        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;

        const $jContext = this.getContext();

        let errorTarget;
        if (!$jContext.find("#enterAuthStep").hasClass("hide")) {
            errorTarget = " #ah-authcode-error-target-1";
        } else if (!$jContext.find("#requestAuthStep").hasClass("hide")) {
            errorTarget = " #ah-authcode-error-target-2";
        } else if (!$jContext.find("#uciRequestAuthStep").hasClass("hide") && $jContext.find("#uciRequestAuthStep").hasClass("js-widget-step")) {
            errorTarget = " #ah-authcode-error-target-3";
        } else {
            errorTarget = "#global-auth-error";
            if (!self._isStandAlone()) {
                if (self._isTokenization() && $("#ah-otp-widget").find("#generic-otp-close-section").length == 0) {

                    let genericAuthCodeCloseBtn =
                        '<section id="generic-otp-close-section" class="action-buttons mb-30"><div class="row"><div class="column large-3 medium-3 small-12"><a href="javascript:void(0);" class="spa-btn spa-btn--primary spa-btn--large" id="generic-otp-close-btn">Close</a></div></div></section>';
                    $("#ah-otp-widget").append(genericAuthCodeCloseBtn);


                    $("#generic-otp-close-btn")
                        .text($('#generic-error-request-authcode-close').text())
                        .off("click")
                        .on("click", e => {
                            window.location.href = "/login/rest/sas/sparta/secure/v1/oauthRedirect?action=Cancel";
                        });
                }
            }
        }

        if (errorType && errorType === "fatal" && this._isStandAlone()) {
            errorTarget = " #global-auth-error";
        }


        if (self._isCAW() && (_.includes(errorTarget, "#ah-authcode-error-target") || errorTarget === "#global-auth-error")) {
            errorTarget = " #ah-authcode-error-target-caw";
        }

        $jContext.find(errorTarget).empty();

        if ($jContext.is(".spa-ui-modal")) {
            errorTarget = ".spa-ui-modal " + errorTarget;
        } else {
            if (errorTarget && errorTarget.charAt(0) === '#') {
                errorTarget = `#${$jContext.attr("id")} ${errorTarget}`;
            } else {

                errorTarget = `#${$jContext.attr("id")}${errorTarget}`;
            }
        }

        self.spartaMessageUtil.showErrorMessage(errorTarget, title, content, { insert: "replace", size: "medium" });
        window.setTimeout(function() {

            $(errorTarget).find('.spartaMessage-content').attr('tabindex', 0).attr('aria-live', 'rude').focus();
        }, 100);


        if (content === " ") {
            $jContext.find(".spartaMessage-icon").removeAttr("style");
            $jContext
                .find(".spartaMessage-text")
                .addClass("spartaMessage-no-text")
                .removeClass("spartaMessage-text");
        }
    }

    confirmBeforeClose() {

        this.showStep(this.parentModule.SECTIONS.OTP.CONFIRM_BEFORE_CLOSE);
    }

    _populateContactsForUI(contactType, customerContacts, isIVRDown) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const $jContext = self.getContext();

        let contactListWrapper = "";
        $jContext.find("#emailList,phoneList").empty();
        if (contactType === "email") {

            contactListWrapper = "#emailList";

            otacModule.CACHED.contacts.TEMPLATE_DATA = {
                contactType: contactType,
                isEmailContact: true,
                isSingleContact: customerContacts.length == 1,
                totalContacts: customerContacts.length,
                "contact-label": otacModule.i18n["select-email"],
                contacts: customerContacts
            };

            $jContext.find(contactListWrapper).html(otacModule.templates.contacts(otacModule.CACHED.contacts.TEMPLATE_DATA));
            $jContext.find("#contactEmailsWrapper").removeClass("hide");
            $jContext.find(".js-phonecontext").addClass("hide");
            $jContext.find(".js-emailcontext").removeClass("hide");
        } else if (contactType === "phone") {

            contactListWrapper = "#phoneList";
            otacModule.CACHED.contacts.TEMPLATE_DATA = {
                contactType: contactType,
                isPhoneContact: true,
                isSingleContact: customerContacts.length == 1,
                totalContacts: customerContacts.length,
                "contact-label": otacModule.i18n["select-phone"],
                contacts: customerContacts
            };

            $jContext.find(contactListWrapper).html(otacModule.templates.contacts(otacModule.CACHED.contacts.TEMPLATE_DATA));









            $jContext
                .find("#contactPhonesWrapper .txt-voice-wrapper .spa-input-options-wrapper")
                .find("label,input")
                .each(function() {
                    if ($(this).is(":input")) {
                        $(this).attr("id", "mod-" + $(this).attr("id"));
                    } else if ($(this)[0].tagName.toLowerCase() === "label") {
                        $(this).attr("for", "mod-" + $(this).attr("for"));
                    }
                })
                .end()
                .find("input")[0].checked = true;

            $jContext.find(".js-phonecontext").removeClass("hide");
            $jContext.find(".js-emailcontext").addClass("hide");

            $jContext.find("#contactPhonesWrapper").removeClass("hide");
            if (isIVRDown === true || (_.get(otacModule, "clientParams.showVoice") === false)) {
                $jContext.find("#contactPhonesWrapper .txt-voice-wrapper .spa-input-options-wrapper.input-radio-voice").remove();
            }
        }
    }





    sendCodeSuccessHandler(jData, selectedContactType) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const $jContext = self.getContext();

        $jContext.find("#otp-request-tw-buttons #send-otp-code").attr("disabled", "disabled");
        if (jData && jData.completion && jData.completion.code === "SUCCESS") {
            self.publishEvent(otacModule.EVENTS.OTP_SEND_CODE_SUCCESS);

            const enterOTPStep = $jContext.find(otacModule.SECTIONS.OTP.ENTER_OTP);
            let selectedContactTypeLower = selectedContactType.toLowerCase();
            enterOTPStep.find(".js-seltype").addClass("hide");
            enterOTPStep.find(`.js-seltype-${selectedContactTypeLower}`).removeClass("hide");

            if (selectedContactTypeLower === "voice") {

                selectedContactTypeLower = "text";
            }










            const selectedContactData = self.getSelectedContactData();
            if (self._isUCI()) {
                enterOTPStep.find(".js-selected-contact").text(otacModule._data.OTP.selectedMaskedContact);
            } else {
                if (selectedContactTypeLower === 'text') {
                    enterOTPStep.find(".js-selected-contact").text(selectedContactData.label.replace(/\*/g, "x"));
                } else {
                    if (typeof spaParams !== 'undefined' && spaParams.siteName === "secure-ah-enroll") {
                        let emailId = selectedContactData.label;
                        let maskedEmail = emailId.replace(/^(.)(.*)(.@.*)$/,
                            (_, a, b, c) => a + b.replace(/./g, '*') + c
                        );
                        enterOTPStep.find(".js-selected-contact")
                            .text(maskedEmail);
                    }
                    else {
                        enterOTPStep.find(".js-selected-contact")
                            .text(selectedContactData.label);
                    }
                }
            }

            self.clearAllFields("enter-otp");


            $jContext.find(".js-card-debit,.js-card-credit").addClass("hide");


            if (otacModule.CACHED.cardInfo && otacModule.CACHED.cardInfo.length > 0) {


                let i = 0;
                let cardDetails = [];

                for (i = 0; i < otacModule.CACHED.cardInfo.length; i++) {
                    const currentCard = {};
                    currentCard.inputName = otacModule.cardsRadioName;
                    currentCard.id = `${otacModule.CACHED.cardInfo[i].type.name}${i + 1}`;
                    currentCard.value = otacModule.CACHED.cardInfo[i].cardNumber;
                    currentCard.label = otacModule.CACHED.cardInfo[i].cardNumber;
                    currentCard.labelToDisplay = otacModule.CACHED.cardInfo[i].cardNumber;
                    cardDetails.push(currentCard);
                }

                otacModule.CACHED.cardInfo.TEMPLATE_DATA = {
                    cardType: otacModule.CACHED.cardInfo[0].type.name,
                    isCreditCard: otacModule.CACHED.cardInfo[0].type.name === "CREDIT",
                    isDebitCard: otacModule.CACHED.cardInfo[0].type.name === "DEBIT",
                    totalCards: otacModule.CACHED.cardInfo.length,
                    "card-label": otacModule.i18n["select-" + otacModule.CACHED.cardInfo[0].type.name],
                    cards: cardDetails
                };

                $jContext.find("#debitc-validate-wrapper").html(otacModule.templates.debitCreditCards(otacModule.CACHED.cardInfo.TEMPLATE_DATA));
                if ($jContext.find("#debitc-validate-wrapper").find("input").length === 1) {

                    $jContext.find("#debitc-validate-wrapper").find("input")[0].checked = true;
                }

                if($jContext.find("#debitc-validate-wrapper").find("input").length > 1) {
                    for (i = 0; i < otacModule.CACHED.cardInfo.length; i++) {
                        if(otacModule.CACHED.cardInfo[i].checked){
                            $jContext.find("#debitc-validate-wrapper").find("input")[i].checked = true;
                        }
                    }
                }


                $jContext.find(".js-card-debit,.js-card-credit").addClass("hide");
                let cardSectionToShow = "";
                if (otacModule.CACHED.cardInfo.TEMPLATE_DATA.isCreditCard) {
                    cardSectionToShow = ".js-card-credit";
                } else if (otacModule.CACHED.cardInfo.TEMPLATE_DATA.isDebitCard) {
                    cardSectionToShow = ".js-card-debit";

                }
                $jContext.find(cardSectionToShow).removeClass("hide");
            }


            if(!$jContext.find(".js-card-debit").hasClass("hide")||!($jContext.find(".js-card-credit").hasClass("hide"))){
                $jContext.find("#cawHeader").addClass("hide");
                $jContext.find("#sectionHeader").removeClass("hidden");
                if(selectedContactTypeLower==="text") {
                    enterOTPStep.find(".js-seltype").addClass("hide");
                    $jContext.find("#numberedOTPThroughPhoneHeader").removeClass("hide");
                }
                else {
                    enterOTPStep.find(".js-seltype").addClass("hide");
                    $jContext.find("#numberedOTPThroughEmailHeader").removeClass("hide");
                }
            }
            else {
                $jContext.find("#cawHeader").removeClass("hide");
                $jContext.find("#sectionHeader").addClass("hidden");
            }

            if (self._isStandAlone()) {
                $jContext.find(".authcode-tokenization").addClass("hidden");
                $jContext.find(".authcode-caw").removeClass("hidden");









            } else {
                if (self._isTokenization()) {
                    $jContext.find(".authcode-tokenization").removeClass("hidden");
                    $jContext.find(".authcode-caw:not(.js-seltype)").addClass("hidden");
                    $jContext.find(".authcode-all").removeClass("hidden");
                    $jContext.find(".tw-authcode-entry-content").addClass("hidden");
                    $jContext.find(`.tw-authcode-sent-${selectedContactTypeLower}`).removeClass("hidden");
                    $jContext.find(`.tw-authcode-check-${selectedContactTypeLower}`).removeClass("hidden");
                    $("#otp-entry-input-container").addClass("mb-30");
                    $("label[for=otp-code]").html("Authorization Code");



                    $("#otp-entry-tw-buttons a")
                        .addClass("spa-btn--large")
                        .removeClass("spa-btn--small");
                }
            } 




            otacModule.recentActiveStep = otacModule.SECTIONS.OTP.ENTER_OTP;

            self.showStep(otacModule.SECTIONS.OTP.ENTER_OTP);
        } else {

            self.publishEvent(otacModule.EVENTS.OTP_SEND_CODE_FAILURE);
            self.handleError({
                errorType: otacModule.EVENTS.OTP_SEND_CODE_FAILURE,
                data: jData
            });
        }
        otacModule.sendOTPInProcess = false;
    }


    _timedHideContainer() {
        let self = this;
        const otacModule = this.parentModule;

        if (self._isModal() || self._isUCI()) {
            window.setTimeout(function() {
                self.closeOtacModal(self, $, otacModule);
            }, 7000);
        } else {

            self._finalize(self);
        }
    }


    _finalize(self) {
        const otacModule = this.parentModule;
        self.cawCommons._hideAll(otacModule.SECTIONS.HEAD, self.getContext());
    }

    closeOtacModal(self, $, otacModule) {
        self.spartaUILayersUtility.closeLayer();
        $("[id*=ah-otp-widget-modalwindow-]").remove();
        otacModule.$moduleModalWindowContext = null;
    }

    _isStandAlone() {
        const widgetConfig = this.parentModule.Store.getData("widgetConfigData");
        return !(widgetConfig && widgetConfig.usecase);
    }

    _isTokenization() {
        const widgetConfig = this.parentModule.Store.getData("widgetConfigData");
        return widgetConfig && widgetConfig.usecase === "tokenization" && widgetConfig.originatingFrom !== 'XID';
    }

    _isCAW() {
        return this.parentModule.cawData && typeof this.parentModule.cawData.originatingFrom !== 'undefined'                                                           ;
    }

    _isModal() {
        return this.parentModule.WIDGET_TYPE.MODAL === this.parentModule.clientParams["widget-type"];
    }

    _isUCI() {
        return this.parentModule.WIDGET_TYPE.UCI === this.parentModule.clientParams["widget-type"];
    }

    _isPage() {
        return this.parentModule.WIDGET_TYPE.PAGE === this.parentModule.clientParams["widget-type"];
    }

    _isRequestAuthSectionVisible() {
        return !this.getContext()
            .find("#requestAuthStep")
            .hasClass("hide");
    }

    _isEnterAuthSectionVisible() {
        return !this.getContext()
            .find("#enterAuthStep")
            .hasClass("hide");
    }

    _fixInputsForMultiOtac() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const $jContext = self.getContext();
        const authCodeComponentWrapperId = $jContext.attr('id')

        _.forOwn(otacModule.INPUT.INITIAL, function(inputId, key) {
            const $input = $jContext.find(`${inputId}:not(.input-id-upd)`);
            const $inputWrapper = $input.parent('.spa-input:not(.spa-input-upd)');

            if ($input.length !== 0) {

                self._updateInputId($inputWrapper, authCodeComponentWrapperId, inputId, key);
            } else {
                console.log(`Not found: ${inputId} in ${authCodeComponentWrapperId}.`);
            }

        });

        $jContext.find('.visa-cvv-wrapper:not(.img-added)').html($jContext.find('.js-img-visa').clone().wrap('<p>').removeClass('hidden').parent().html()).addClass('img-added');
        $jContext.find('.amex-cvv-wrapper:not(.img-added)').html($jContext.find('.js-img-amex').clone().wrap('<p>').removeClass('hidden').parent().html()).addClass('img-added');






    }






    _updateInputId($inputWrapper, prefix, inputId, inputKey) {
        const $this = $inputWrapper;
        const otacModule = this.parentModule;

        if ($this.is(':not(.spa-input-upd)')) {
            $this.addClass('spa-input-upd');

            const oldID = $this.find('input').attr('id');
            const newID = `${prefix}-${oldID}`;
            const $label = $this.find('label');
            const $input = $this.find('input');
            const $toggleTrigger = $this.find('.toggle-trigger');
            const $closeTrigger = $this.find('.close-trigger');
            const $inputHelp = $this.find('.input-help');
            const $spaErrorMessage = $this.find('.spa-input-error-message');

            console.log(`Fixing ${inputId} in ${prefix}. From ${oldID} to ${newID}`);

            $label.attr('for', _.replace($label.attr('for'), oldID, newID));
            $input.attr('id', _.replace($input.attr('id'), oldID, newID)).addClass('input-id-upd');
            $input.attr('name', _.replace($input.attr('name'), oldID, newID));
            $input.attr('aria-describedby', _.replace($input.attr('aria-describedby'), oldID, newID));

            $toggleTrigger.attr('id', _.replace($toggleTrigger.attr('id'), oldID, newID));
            $closeTrigger.attr('id', _.replace($closeTrigger.attr('id'), oldID, newID));

            $inputHelp.attr('id', _.replace($inputHelp.attr('id'), oldID, newID));
            $spaErrorMessage.attr('id', _.replace($spaErrorMessage.attr('id'), oldID, newID));

            otacModule.INPUT.ACTUAL[inputKey] = `#${newID}`;

            if (_.includes(otacModule.PASSWORDINPUTS, inputId)) {
                otacModule.PASSWORDINPUTS.push(otacModule.INPUT.ACTUAL[inputKey]);
            }
        } else {
            console.log(`${inputId} already fixed in ${prefix}`);
        }
    }





    validateFields(screenName) {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const $jContext = self.getContext();

        let validationSuccess = true;
        let errorCode = "";
        let invalidInputFields = []; 


        self.hideAllErrors();


        $jContext.find("[data-validation]:visible").each(function() {

            if (validationSuccess) {
                const $currentElement = $(this);
                const elemVal = $(this).val();
                const dataValidation = $(this).attr("data-validation");

                const validationRules = $.parseJSON($(this).attr("data-validation"));
                _.forOwn(validationRules, function(value, key) {

                    if (validationSuccess) {
                        if (key === "empty") {
                            if (_.trim(elemVal).length === 0) {
                                errorCode = value;
                                validationSuccess = false;
                                invalidInputFields.push($currentElement);
                            }
                        } else if (key === "numeric-only") {
                            if (!/^\d+$/.test(elemVal)) {
                                errorCode = value;
                                validationSuccess = false;
                                invalidInputFields.push($currentElement);
                            }
                        } else {
                            var validationRule = validationRules[key];
                            if ($.isPlainObject(validationRule)) {
                                var validateRegex = validationRule['regex'];
                                if (new RegExp(validateRegex).test(elemVal) === false) {
                                    errorCode = validationRule['code'];
                                    validationSuccess = false;
                                    invalidInputFields.push($currentElement);
                                }
                            }
                        }
                    } 
                });
            }
        });

        if (validationSuccess) {

            const onScreenCards = $jContext.find("input[name=cardsSelect]:visible");
            if (onScreenCards.length > 0) {
                if ($jContext.find("input[name=cardsSelect]:visible:checked").length !== 1) {
                    if ($jContext.find(`${otacModule.INPUT.ACTUAL.CVV}:visible`).length > 0) {
                        errorCode = "INVALID_AUTHCODE_OR_CREDIT_CARD";
                    } else {
                        errorCode = "INVALID_AUTHCODE_OR_DEBIT_CARD";
                    }
                    $jContext.find("input[name=cardsSelect]:visible").parents('#cardsRadio').find('> label').addClass('spa-error-form-label--validation');
                    validationSuccess = false;
                }
            }

        }

        $.each(invalidInputFields, function(a, elem) {
            elem.addClass('spa-error-form-input--validation');
            elem.siblings('label').addClass('spa-error-form-label--validation');
        });



        if (validationSuccess === false) {
            if ($jContext.find("input[name=cardsSelect]:visible").length > 0) {
                if ($jContext.find(`${otacModule.INPUT.ACTUAL.CVV}:visible`).length > 0) {
                    errorCode = "INVALID_AUTHCODE_OR_CREDIT_CARD";
                } else {
                    errorCode = "INVALID_AUTHCODE_OR_DEBIT_CARD";
                }
            }

            if (errorCode === "INVALID_AUTH_CODE" && self._isCAW()) {

                errorCode = "E0017";
            }
            self.publishEvent(otacModule.EVENTS.OTP_VALIDATE_CODE_FAILURE);
            self.handleError({
                errorType: otacModule.EVENTS.OTP_VALIDATE_CODE_FAILURE,
                data: { errorInfo: [{ code: errorCode }] }
            });
        }
        return validationSuccess;
    }







    showStep(stepId, _context) {
        const self = this;
        const otacModule = this.parentModule;

        let context = _context ? _context : self.getContext();

        self.cawCommons._showOnly(otacModule.SECTIONS.OTP, stepId, context);

        if (self.isModalAlreadyOpened()) {
            this.setDefaultFocus(context,  stepId);









        }
    }

    setDefaultFocus(context, stepId) {
        let liveElement = context.find('.spa-content');
        liveElement.attr('aria-live', 'rude');

        if(typeof stepId !== 'undefined') {
            let elementToFocus = context.find('a.spa-ui-layer-close');
            elementToFocus.find('.ada-hidden').text('close Layer ' + context.find(stepId).find('.step-header:visible:first').text());
            elementToFocus.focus();
        }
    }

    showFirstScreen($context) {
        const self = this;
        const otacModule = this.parentModule;

        if (self._isUCI()) {
            otacModule.recentActiveStep = otacModule.SECTIONS.OTP.UCI_REQUEST_OTP;

            self.showStep(otacModule.SECTIONS.OTP.UCI_REQUEST_OTP, $context);
        } else {
            otacModule.recentActiveStep = otacModule.SECTIONS.OTP.REQUEST_OTP;

            self.showStep(otacModule.SECTIONS.OTP.REQUEST_OTP, $context);
        }
    }

    showNoContactsStep() {
        const self = this;
        const otacModule = this.parentModule;
        const $jContext = self.getContext();
        const enterOTPStep = $jContext.find(otacModule.SECTIONS.OTP.ENTER_OTP);

        enterOTPStep.find(".js-seltype").addClass("hide");


        self.clearAllFields("enter-otp");

        $jContext.find(".js-card-debit,.js-card-credit").addClass("hide");

        $jContext.find(".authcode-caw").removeClass("hidden");
        $jContext.find("#sectionHeader").addClass("hidden");
        $jContext.find("#cawHeader").removeClass("hide");
        if (self._isTokenization()) {
            enterOTPStep.find(".authcode-caw").addClass("hidden");
            enterOTPStep.find(".authcode-tokenization").removeClass("hidden");
        }
        enterOTPStep.find(".authcode-all").removeClass("hide");

        $jContext.find(".js-hide-nocontacts").remove();
        $jContext
            .find(".js-show-nocontacts")
            .removeClass("hide")
            .removeClass("hidden");

        otacModule.recentActiveStep = otacModule.SECTIONS.OTP.ENTER_OTP;

        self.showStep(otacModule.SECTIONS.OTP.ENTER_OTP);
    }





    getSelectedContactData() {
        const self = this;
        const otacModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const $jContext = self.getContext();

        const selectedContactData = {};

        if (otacModule.CACHED.contacts.TEMPLATE_DATA.totalContacts === 1) {
            selectedContactData.label = otacModule.CACHED.contacts.TEMPLATE_DATA.contacts[0].label;
            selectedContactData.value = otacModule.CACHED.contacts.TEMPLATE_DATA.contacts[0].value;
            selectedContactData.type =
                otacModule.CACHED.contacts.TEMPLATE_DATA.contactType === "email" ? "EMAIL" : $jContext.find(`input[name=${otacModule.textVoiceRadio}]:checked`).val();
        } else if (otacModule.CACHED.contacts.TEMPLATE_DATA.totalContacts > 1) {
            const selectedContact = $jContext.find(`input[name=${otacModule.otpRadioName}]:checked`);
            selectedContactData.label = selectedContact.data("contactlabel");
            selectedContactData.value = selectedContact.val();
            selectedContactData.type =
                otacModule.CACHED.contacts.TEMPLATE_DATA.contactType === "email" ? "EMAIL" : $jContext.find(`input[name=${otacModule.textVoiceRadio}]:checked`).val();
        } else {
            throw "Incorrect data `totalContacts`. ";
        }

        return selectedContactData;
    }





    _setupImportantTitle($jContext) {
        const otacModule = this.parentModule;
        const self = this;

        let $pageTitleSibling = $jContext.siblings('.ah-page-title-module');
        let $importantTitle = $pageTitleSibling.find('#ahPageTitleContainer #title-content .important-text');
        let $regularTitle = $pageTitleSibling.find('#ahPageTitleContainer #title-content .regular-text');
        let $spaCloseLink = $pageTitleSibling.closest('.spa-content').find('.spa-header .spa-ui-layer-close');

        if ($importantTitle.length > 0 && $importantTitle.text() && $importantTitle.text().trim()) {
            otacModule._debug('eligible to set up important notice listener: ' + $jContext.find('a, button').length);

            $regularTitle.addClass('hidden');
            $importantTitle.removeClass('hidden');

            let $linksAndButtons = $jContext.find('a, button');

            $linksAndButtons.off('click.importantTitleRemoval').on('click.importantTitleRemoval', (function() {
                otacModule._debug('title removal from links/buttons');
                self._hideImportantTitle(otacModule, $importantTitle, $regularTitle);
                if($spaCloseLink.length > 0) {
                    self._deRegisterImportantTitleRemoval(otacModule, 'click.modalImportantTitleRemoval', $spaCloseLink);
                }
                self._deRegisterImportantTitleRemoval(otacModule, 'click.importantTitleRemoval', $linksAndButtons);
                return true;
            }));

            if($spaCloseLink.length > 0) {
                $spaCloseLink.off('click.modalmportantTitleRemoval').on('click.modalImportantTitleRemoval', (function() {
                    otacModule._debug('title removal from close modal');
                    self._hideImportantTitle(otacModule, $importantTitle, $regularTitle);
                    if($spaCloseLink.length > 0) {
                        self._deRegisterImportantTitleRemoval(otacModule, 'click.modalImportantTitleRemoval', $spaCloseLink);
                    }
                    self._deRegisterImportantTitleRemoval(otacModule, 'click.importantTitleRemoval', $linksAndButtons);
                    return true;
                }));
            }
        }
    }

    _hideImportantTitle(otacModule, $importantTitle, $regularTitle) {
        otacModule._debug('hiding important title');

        if ($importantTitle.is(':visible')) {
            otacModule._debug('important title is visible');
        } else {
            otacModule._debug('important title is not visible'); 
        }
        $importantTitle.addClass('hidden');
        $regularTitle.removeClass('hidden');
    }

    _deRegisterImportantTitleRemoval(otacModule, eventName, $selector) {
        otacModule._debug('de-register title removal listeners for eventName: ' + eventName);

        window.setTimeout(function () {
            otacModule._debug('important notice listener removal: ' + eventName);
            $selector.off(eventName);
        }, 100);
    }

    publishEvent(eventName, data) {
        const eventToPublish = this.getNSAwareEvent(eventName);
        this.parentModule._debug(`Publishing Event: ${eventToPublish}`);
        this.parentModule.Events.pub(eventToPublish, data);
    }
    subscribeEvent(eventName, refMethod) {
        const eventToSubscribe = this.getNSAwareEvent(eventName);
        console.log(`Subscribed to Event ${eventToSubscribe}`);
        this.parentModule.Events.sub(eventToSubscribe, refMethod);
    }

    getNSAwareEvent(eventName) {
        return eventName + this.parentModule["events-namespace"];
    }
}
